import React from 'react';

// Links typed into page text, mostly from the old site, name a file's
// @@download address in full. That address makes the browser save the file
// (and Volto adds a download attribute), so a PDF can't be read in the tab.
// @@display-file shows what the browser can show and still saves the rest.
const DOWNLOAD = /\/@@download\/file(?=$|[?#])/;

export const inlineFileUrl = (url) =>
  typeof url === 'string' ? url.replace(DOWNLOAD, '/@@display-file/file') : url;

export const withInlineFile = (element) => {
  const external = element?.data?.link?.external;
  const url = inlineFileUrl(element?.url);
  const externalLink = inlineFileUrl(external?.external_link);
  if (url === element?.url && externalLink === external?.external_link) {
    return element;
  }
  return {
    ...element,
    ...(url !== element?.url ? { url } : {}),
    ...(externalLink !== external?.external_link
      ? {
          data: {
            ...element.data,
            link: {
              ...element.data.link,
              external: { ...external, external_link: externalLink },
            },
          },
        }
      : {}),
  };
};

// The two link elements in text: "link" (what the old site's pages use) and
// "a" (the editor's advanced link)
export default function install(config) {
  const elements = config.settings.slate?.elements;
  if (!elements) return config;

  ['link', 'a'].forEach((type) => {
    const LinkElement = elements[type];
    if (!LinkElement) return;
    elements[type] = (props) => (
      <LinkElement {...props} element={withInlineFile(props.element)} />
    );
  });
  return config;
}
